import dayjs from 'dayjs'
import { t } from 'i18next'
import React, { Fragment } from 'react'
import { Person } from '../../../../model/person.model'
import { compareIfMonthAndDayAreEqual } from '../../../../util/math'

export const calculateAge = (birthdate: Date): number => {
  if (!birthdate) {
    return 0
  }
  const diffMs = Date.now() - birthdate.getTime()
  const ageDt = new Date(diffMs)

  return Math.abs(ageDt.getUTCFullYear() - 1970)
}

export const birthdayBody = (person: Person): JSX.Element => {
  const birthdate = person?.birthdate
  if (!birthdate) {
    return <Fragment />
  }

  const date = new Date(birthdate)

  const age = calculateAge(date)
  const ageString = age > 0 ? `(${age})` : ''
  const hastBirthday = compareIfMonthAndDayAreEqual(dayjs().toDate(), date)

  const formattedDate = dayjs(date).format(t<string>('locales.dateFormat'))
  const formattedBirthday = `${formattedDate} ${ageString}`

  return (
    <Fragment>
      <span>{formattedBirthday}</span>
      {hastBirthday && <i className={'fas fa-heart ml-2 icon-orange'} />}
    </Fragment>
  )
}

export const dateBody = (data: Date | undefined): JSX.Element => {
  if (!data) {
    return <Fragment />
  }

  const date = new Date(data)

  const formattedDate = dayjs(date).format(t<string>('locales.dateFormatwHour'))

  return <span>{formattedDate}</span>
}

export const shortDateBody = (data: Date | undefined): JSX.Element => {
  if (!data) {
    return <Fragment />
  }

  const date = new Date(data)

  const formattedDate = dayjs(date).format('MM.YYYY')

  return <span>{formattedDate}</span>
}